export default __webpack_public_path__ + "static/eVTSvXNG-b4cd94700816c17b813c281605e06801.svg";